export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6481.e8c949f1.jpg";